import React from 'react';
import { Linking, StyleSheet, Text, View } from 'react-native';
import { getUrlRegex } from '../../../../ChatComponent/utils';

const formatUrl = (url: string) => {
  if (url.length <= 30) return url;
  const firstPart = url.substring(0, 20);
  const lastPart = url.substring(url.length - 10);
  return `${firstPart}...${lastPart}`;
};

export const MessageText = ({
  text,
  isOwn,
}: {
  text: string;
  isOwn: boolean;
}) => {
  const parts = text.split(getUrlRegex());

  return (
    <View>
      {parts.map((part, index) =>
        getUrlRegex().test(part) ? (
          <Text
            key={index}
            style={[styles.linkText, isOwn ? styles.userText : {}]}
            onPress={() => Linking.openURL(part)}
          >
            {formatUrl(part)}
          </Text>
        ) : (
          <Text
            key={index}
            style={
              isOwn
                ? [styles.messageText, styles.userText]
                : [styles.messageText, styles.otherText]
            }
            selectable={true}
          >
            {part}
          </Text>
        )
      )}
    </View>
  );
};
const styles = StyleSheet.create({
  messageText: {
    fontSize: 13,
  },
  userText: {
    color: 'white',
  },
  otherText: {
    color: '#1A2737',
  },
  linkText: {
    color: '#1E90FF', // Blue color for links
    textDecorationLine: 'underline',
  },
});
